import { defineComponent as _defineComponent } from 'vue'
import Vue, { ref,computed } from 'vue'
  import { AloMission } from  '@/models/alo/AloMission'   
  import store from '@/store'
  import distance from '@turf/distance'
  import {point,bearingToAzimuth} from '@turf/helpers'
  import bearing from '@turf/bearing'
  import {posModulo} from  '@/utils/modulo'
  import {i18n} from '@/locale/vueI18n'
  import {buildCoverageIterationMissionUiStateId} from '@/models/ui/CoverageIterationMissionUiState'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageIterationLineDetailGlider',
  props: {
    mission: null,
    glider: null,
    uiid: null
  },
  setup(__props: any) {

const props = __props as {mission:AloMission,glider:string,uiid:string};
  
  
  
  const gliderColor = computed(()=> {
    switch(props.glider){      
      case 'GLIDER2': return '#228be6'
      case 'GLIDER3': return '#40c057'
      case 'GLIDER4': return '#ae3ec9'
      case 'GLIDER5': return '#f03e3e'
      case 'GLIDER6': return '#fcc419'
      case 'GLIDER7': return '#000000'
      default: return 'f76707'
    }
  })

  const coordFormatFilter = computed(()=>store.myGetters.coordFormatFilter)

  const coverageIterationMissionUiStateId = computed(()=>buildCoverageIterationMissionUiStateId(props.uiid,props.glider))
  const coverageIterationMissionUiState = computed(()=>store.myGetters.coverageIterationMissionUiStateByUiid(coverageIterationMissionUiStateId.value))

  const yoIndex = computed(()=> coverageIterationMissionUiState.value?.timelineIndex != -1?coverageIterationMissionUiState.value?.timelineIndex:(props.mission?.yoArray.length-1))

  const yo = computed(() => props.mission?.yoArray?.[yoIndex.value])  
  
  const nextYo = computed(() => {   
    let searchYo = null      
    if(coverageIterationMissionUiState.value?.timelineIndex != -1) {
      let idx = 1
      while(props.mission?.yoArray.length > (yoIndex.value + idx) &&  (searchYo = props.mission?.yoArray[yoIndex.value + idx]).isUnderWater) {
        idx++;
      }        
      if(!searchYo?.isUnderWater) return searchYo?.driftArray?.[0] || searchYo              
    }
    return null
  })

  const canComputeCoord = computed(()=>{
        return nextYo.value?.yoGpsLon && nextYo.value?.yoGpsLat && yo.value?.yoGpsLon && yo.value?.yoGpsLat
  })

  const computedDistance = computed(() => {
    if(canComputeCoord.value){
      return (distance(point([yo.value?.yoGpsLon??0, yo.value?.yoGpsLat??0]),point([nextYo.value?.yoGpsLon??0, nextYo.value?.yoGpsLat??0])) * 1000).toFixed(0)
    }else{
      return '-'
    }
    
  })
  const computedFlightTime = computed(() => {
    if(nextYo.value){
      return Vue.filter("formatDuree")([yo.value.yoGpsDatTime,nextYo.value.yoGpsDatTime],i18n)
    }
    else{
      return '-'
    }
  })
  const computedCog = computed(() => {
    if(canComputeCoord.value){
      return bearingToAzimuth(bearing(point([yo.value.yoGpsLon!, yo.value.yoGpsLat!]),point([nextYo.value?.yoGpsLon??0, nextYo.value?.yoGpsLat??0]))).toFixed(2)
    }
    else{
      return '-'
    }
  })
  const computedDrift = computed(() => {
    if(canComputeCoord.value && yo.value.heading != -9999){
      //@ts-ignore
      return  (posModulo( computedCog.value -  yo.value.heading! + 180,360) - 180).toFixed(2)
    }
    else{
      return '-'
    }
  })
  const computedSog = computed(() => {
    if(canComputeCoord.value){
      return (computedDistance.value??0 / ((nextYo.value?.yoGpsDatTime.getTime()??0 -  yo.value.yoGpsDatTime.getTime())/1000))
    }
    else{
      return '-'
    }
  })

  const missionStartDate = computed(()=>  props.mission?.param?.mission_start_date)
  const missionCurEndDate= computed(()=> (props.mission?.result?.mission_end_date?.length ?? 0) > 0?props.mission?.result?.mission_end_date:props.mission?.result?.current_date)
  const nbYos= computed(()=> props.mission?.result?.cycle_number ?? props.mission?.result?.current_cycle)
  const energy_available= computed(()=> props.mission?.result?.energy_available ?? props.mission?.result?.current_battery)


return { __sfc: true,props, gliderColor, coordFormatFilter, coverageIterationMissionUiStateId, coverageIterationMissionUiState, yoIndex, yo, nextYo, canComputeCoord, computedDistance, computedFlightTime, computedCog, computedDrift, computedSog, missionStartDate, missionCurEndDate, nbYos, energy_available }
}

})